var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 52,
    viewBox: "0 0 82 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 25L0 22.6132L0 28.3868L5 26V25ZM82 25.5L77 22.6132V28.3868L82 25.5ZM4.5 26H77.5V25H4.5V26Z",
    fill: "#9F2225"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 26,
    r: 26,
    fill: "#9F2225"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8401 18.6099C48.8086 17.5779 47.4093 16.998 45.9501 16.998C44.491 16.998 43.0916 17.5779 42.0601 18.6099L41.0001 19.6699L39.9401 18.6099C37.7917 16.4615 34.3085 16.4615 32.1601 18.6099C30.0117 20.7583 30.0117 24.2415 32.1601 26.3899L33.2201 27.4499L41.0001 35.2299L48.7801 27.4499L49.8401 26.3899C50.8721 25.3583 51.4519 23.959 51.4519 22.4999C51.4519 21.0407 50.8721 19.6414 49.8401 18.6099Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveCalendar);
export default __webpack_public_path__ + "static/media/love-calendar.6fb21db507b1791eac5641b30d682bd3.svg";
export { ForwardRef as ReactComponent };